import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';

import { newCustomerResidentialGreenLight } from '../../app/slices/onboarding/onboardingSlice';
import { OnboardingHeader, Stepper } from '../../components';
import * as S from './OnboardingNewCustomerResidentialGreenlight.styles';

import { META_TITLE, New_Cust_Res_Onb_Greenlight } from '../../utils/constants';
import { CustomerResidentialGreenlight } from '../../components/CustomerResidentialGreenlight';

export default function OnboardingNewCustomerResidentialGreenlight({ showDashboard }) {
	const dispatch = useDispatch();
	const history = useHistory();

	const onBack = () => {
		history.push('/onboarding/new-customer/residential/utilities');
	};

	const onNext = (data) => {
		dispatch(newCustomerResidentialGreenLight(data));
		localStorage.setItem(New_Cust_Res_Onb_Greenlight, JSON.stringify(data));
		history.push('/onboarding/new-customer/residential/review');
	};

	useEffect(() => {
		// Set document title
		document.title = `New Customer | ${META_TITLE}`;
	}, []);

	const getDataFromLocalStorage = () => {
		let tempData = localStorage.getItem(New_Cust_Res_Onb_Greenlight);
		tempData = JSON.parse(tempData);
		if (tempData) {
			return tempData;
		}
		return {};
	};

	return (
		<S.Wrapper>
			<OnboardingHeader showDashboard={showDashboard} />
			<Stepper
				activeStep={3}
				steps={[
					{ id: 1, label: 'Location' },
					{ id: 2, label: 'Application' },
					{ id: 3, label: 'Utilities' },
					{ id: 4, label: 'Greenlight' },
					{ id: 5, label: 'Review' },
				]}
			/>
			<CustomerResidentialGreenlight onboarding pageHeading="Add Greenlight" getDataFromLocalStorage={getDataFromLocalStorage} onBackFunc={onBack} onNextFunc={onNext} allowNo={true} />
		</S.Wrapper>
	);
}

OnboardingNewCustomerResidentialGreenlight.propTypes = {
	showDashboard: PropTypes.bool,
};
